import { Injectable, Injector } from '@angular/core';
import { ApplicationConstant } from '../../application.constant';
import { BaseQuestion } from '../../shared/extended-class/base-question';
import { LookUpMasterModel } from '../../shared/models/lookup-master/lookup-master.model';
import { CustomerJourneyService } from '../service/customer-journey.service';

@Injectable({
  providedIn: 'root'
})
export class BaseCJQuestion extends BaseQuestion {
  protected customerJourneyService: CustomerJourneyService;
  constructor(serviceInjector: Injector) {
    super(serviceInjector);
    this.customerJourneyService = serviceInjector.get(CustomerJourneyService);
  }

  protected getQuestionModelByKey(questionkey: string): LookUpMasterModel {
    return ApplicationConstant.lookMasterDetails.filter((f) => f.QuestionNumber === questionkey)[0];
  }

  protected getAllSectionQuestionText(sectionNumber: number, isTelephoneQuestionEnabled: boolean): string {
    let questionTextModel = '';
    if (isTelephoneQuestionEnabled) {
      questionTextModel = this.getQuestionModelBySection(sectionNumber)
        ?.filter((q) => q.QuestionText.length > 0)
        ?.map((q) => q.QuestionText)
        ?.join(' - ');
    } else {
      questionTextModel = this.getQuestionModelBySection(sectionNumber)
        ?.filter((q) => q.QuestionText.length > 0 && q.RiskNode !== 'phone')
        ?.map((q) => q.QuestionText)
        ?.join(' - ');
    }
    return questionTextModel;
  }

  protected getQuestionModelBySection(sectionNumber: number): LookUpMasterModel[] {
    return ApplicationConstant.lookMasterDetails.filter((f) => f.SectionName === 'section' + sectionNumber);
  }

  protected addGTMAnswer(questionKey: string, answerStr: string) {
    this.gtmDatalayerUiService.addAnswer('cjanswer', questionKey, answerStr).toPromise();
  }

  protected addGTMEcomEvent(isTelephoneQuestionEnabled: boolean) {
    if (isTelephoneQuestionEnabled) {
      this.gtmDatalayerUiService.addEcomEvent().toPromise();
    }
  }
}
